import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding-bottom: 15px;
`;

export const Flex = styled.div`
  display: flex;
  gap: 7px;
  width: 100%;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  ${({ width }) => (width ? `width: ${width}px; min-width: ${width}px;` : 'width: 100%')};
  min-height: 40px;
  border-radius: var(--border-radius8);
  background-color: ${({ $isRed, gray }) => ($isRed && '#fdd7d7') || (gray && 'var(--color-greyEC)') || 'none'};
  color: ${({ gray }) => (gray ? 'var(--color-grey97)' : 'var(--color-grey6A)')};
  font-size: var(--font-size13);
  font-weight: ${({ gray }) => (gray ? 'var(--font-weight500)' : 'var(--font-weight400)')};
  line-height: 1.15;
  letter-spacing: 0.5px;
  padding: 0 10px;
`;

export const ItemWrap = styled.div`
  border-radius: var(--border-radius8);
`;

export const Text = styled.p`
  width: 100%;
  border-bottom: 1px solid #cfcfcf;
  padding: 7px 10px;
  font-size: var(--font-size13);
  font-weight: var(--font-weight500);
  line-height: 1.15;
  letter-spacing: 0.5px;
  color: var(--color-grey6A);
`;
